import { Typography } from '@mui/material';


function GuideForQR(){
	
	return (
    <div className='container' style={{ padding: "64px 1vw 64px 3vw" }}>
      <Typography variant="h4" component="h4" mb={4}>
		How to install Amazfit Watch Face or Apps using QR Code through Zepp App. ( Amazfit Balance, GTR 4, Active watch only )
      </Typography>
      
	  <br></br>
			
			<h3>1. Open Zepp app and Turn On Developer Mode</h3>
			 <br></br>
				<p>Go to &quot;Profile&quot; =&gt; &quot;Settings&quot; =&gt; &quot;About&quot; and click the Zepp icon 7 times in a row until a pop-up window appears</p>
				 <br></br>
				<img src="https://getech2018.github.io/policy/devlopermode.png"  />
				<br></br>
			<h3>2. Scan QR Code</h3>
			<br></br>
				<li>Go to &quot;Devices&quot; =&gt; &quot;Select Your Watch&quot; 	=&gt; &quot;Developer mode&quot;</li>
				<li>Click on &quot;+&quot; icon at the top right corner.</li>
				<li>Select &quot;Scan&quot; option from the menu</li>
				<br></br>
				<p>Scan QR Code for the Watch Face or App that you want to install from our Apps or website. Selected Watch Face or App will get installed on your Amazfit watch.</p>
				
				
				<br></br>
				<img src="https://getech2018.github.io/policy/syncqrcode.jpg" />
				<br></br>
				
      
    </div>
	);
}
export default GuideForQR